import { useEffect } from 'react'
import { FieldValues, UseFormReturn } from 'react-hook-form'

import useTranslate from '../../lib/hooks/use-translate'

export function useDynamicFormSchema<T extends FieldValues>(form: UseFormReturn<T>) {
  const { currentLanguage } = useTranslate()
  useEffect(() => {
    // Update resolver dynamically
    form.reset(
      { ...form.getValues() }, // Retain current form values
      { keepValues: true } // Ensure user-entered values persist
    )

    // Update resolver directly
  }, [currentLanguage])
}
